module.exports = __webpack_public_path__ + "media/images/countrysquared/lu-20178afafe28703ccd2e22c39507b079.svg";